<template>
  <form @submit.prevent="submitForm()">
    <div class="page-wrap p-3">
      <div class="mt-3 mb-3">
        <a :href="`/students-grants-nutrition`">
          <span><i class="fa fa-chevron-left" aria-hidden="true"></i></span>
          Назад
        </a>
      </div>

      <div class="page-header p-3 mb-3 mt-3">
        <h3>Редактирование количество дней по питанию</h3>
      </div>
    </div>
    <div class="page-content mt-3 mb-3">

      <div class="card">
        <div class="card-header">
          <h6>Обучающийся</h6>
        </div>
        <div class="card-body">
          <div class="col-md-12">
            <div class="row col-md-9">
              <div class="el-input-group">
                <label class="form-label col-md-3">
                  ИИН
                </label>
                <div class="col-md-9">
                  {{ student.iin }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-9">
              <div class="el-input-group">
                <label class="form-label col-md-3">
                  Ф.И.О.
                </label>
                <div class="col-md-9">
                  {{ student.lastname }} {{ student.firstname }}
                  {{ student.patronymic }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-9">
              <div class="el-input-group">
                <label class="form-label col-md-3">
                  Академическая степень
                </label>
                <div class="col-md-9">
                  {{ student?.degree?.nameRu }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h6>Общая сумма: {{ student.nutrition.totalSum.toFixed(2) }}</h6>
          Формула: {{ formula }} + {{ formulaAdditional }} = {{ student.nutrition.totalSum.toFixed(2) }}
        </div>
        <div class="card-body">
          <div class="row col-md-12">
            <div class="col-md-6">
              <div class="card">
                <div class="card-header">
                  <h6>До 18 лет</h6>
                </div>
                <div class="card-body">
                  <div class="row col-md-12">
                    <div class="el-input-group">
                      <label for="workingDays" class="form-label col-md-6">
                        Количество рабочих дней
                      </label>
                      <div class="col-md-6">
                        <input
                            id="workingDays"
                            type="number"
                            v-model="student.nutrition.workingDays"
                            v-on:change="onChange()"
                            :disabled="isDisabled()"
                            class="form-control"
                            :min="0"
                            :step="1"
                            required
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row col-md-12">
                    <div class="el-input-group">
                      <label for="weekendDays" class="form-label col-md-6">
                        Количество выходных дней
                      </label>
                      <div class="col-md-6">
                        <input
                            id="weekendDays"
                            type="number"
                            v-model="student.nutrition.weekendDays"
                            v-on:change="onChange()"
                            :disabled="isDisabled()"
                            class="form-control"
                            :min="0"
                            :step="1"
                            required
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row col-md-12">
                    <div class="el-input-group">
                      <label for="holidayDays" class="form-label col-md-6">
                        Количество праздничных дней
                      </label>
                      <div class="col-md-6">
                        <input
                            id="holidayDays"
                            type="number"
                            v-model="student.nutrition.holidayDays"
                            v-on:change="onChange()"
                            :disabled="isDisabled()"
                            class="form-control"
                            :min="0"
                            :step="1"
                            required
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row col-md-12">
                    <div class="el-input-group">
                      <label for="vacationDays" class="form-label col-md-6">
                        Количество каникулярных дней
                      </label>
                      <div class="col-md-6">
                        <input
                            id="vacationDays"
                            type="number"
                            v-model="student.nutrition.vacationDays"
                            v-on:change="onChange()"
                            :disabled="isDisabled()"
                            class="form-control"
                            :min="0"
                            :step="1"
                            required
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card">
                <div class="card-header">
                  <h6>После 18 лет</h6>
                </div>
                <div class="card-body">
                  <div class="row col-md-12">
                    <div class="el-input-group">
                      <label for="workingDaysAdults" class="form-label col-md-6">
                        Количество рабочих дней
                      </label>
                      <div class="col-md-6">
                        <input
                            id="workingDaysAdults"
                            type="number"
                            v-model="student.nutrition.workingDaysAdults"
                            v-on:change="onChange()"
                            :disabled="isDisabled()"
                            class="form-control"
                            :min="0"
                            :step="1"
                            required
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row col-md-12">
                    <div class="el-input-group">
                      <label for="weekendDaysAdults" class="form-label col-md-6">
                        Количество выходных дней
                      </label>
                      <div class="col-md-6">
                        <input
                            id="weekendDaysAdults"
                            type="number"
                            v-model="student.nutrition.weekendDaysAdults"
                            v-on:change="onChange()"
                            :disabled="isDisabled()"
                            class="form-control"
                            :min="0"
                            :step="1"
                            required
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row col-md-12">
                    <div class="el-input-group">
                      <label for="holidayDaysAdults" class="form-label col-md-6">
                        Количество праздничных дней
                      </label>
                      <div class="col-md-6">
                        <input
                            id="holidayDaysAdults"
                            type="number"
                            v-model="student.nutrition.holidayDaysAdults"
                            v-on:change="onChange()"
                            :disabled="isDisabled()"
                            class="form-control"
                            :min="0"
                            :step="1"
                            required
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row col-md-12">
                    <div class="el-input-group">
                      <label for="vacationDaysAdults" class="form-label col-md-6">
                        Количество каникулярных дней
                      </label>
                      <div class="col-md-6">
                        <input
                            id="vacationDaysAdults"
                            type="number"
                            v-model="student.nutrition.vacationDaysAdults"
                            v-on:change="onChange()"
                            :disabled="isDisabled()"
                            class="form-control"
                            :min="0"
                            :step="1"
                            required
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="page-footer justify-content-end">
      <b-button variant="success" type="submit" v-if="hasEditPermission()">
        Сохранить
      </b-button>
    </div>
  </form>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import studentNutritionService from "@/services/studentNutritionService";
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import delegationService from "@/services/delegationService";

export default {
  components: {
    VueLoading
  },
  computed: {
    studentId() {
      return this.$route.params.uuid;
    }
  },
  data() {
    return {
      isLoading: false,
      student: {
        uuid: null,
        trancheYear: null,
        trancheNumber: null,
        nutrition: {
          uuid: null,
          workingDays: 0, // Количество рабочих дней
          weekendDays: 0, // Количество выходных дней
          holidayDays: 0, // Количество праздничных дней
          vacationDays: 0, // Количество каникулярных дней
          workingDaysAdults: 0, // Количество рабочих дней
          weekendDaysAdults: 0, // Количество выходных дней
          holidayDaysAdults: 0, // Количество праздничных дней
          vacationDaysAdults: 0, // Количество каникулярных дней
          totalSum: 0,
        },
        universityId: null,
        studentId: null,
        citizenshipId: null,
        iin: null,
        lastname: null,
        firstname: null,
        patronymic: null,
        degreeId: null,
        course: null,
        deducted: null
      },
      socialStatuses: [],
      formula: null,
      formulaAdditional: null,
    };
  },
  methods: {
    init() {
      this.findById(this.studentId);
    },
    async findById(studentId) {
      this.isLoading = true;
      this.student = await studentNutritionService.findById(studentId);
      this.initStudentDefaultValues(this.student);

      this.isLoading = false;
    },
    async submitForm() {
      if (!this.hasEditPermission()) {
        return;
      }

      try {
        this.isLoading = true;

        this.student = await studentNutritionService.save(this.student);
        this.initStudentDefaultValues(this.student);

        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
    isFromUniversity(university) {
      if (this.student == null) {
        return false;
      }
      return this.student.universityId === university.id;
    },
    initStudentDefaultValues(student) {
      if (student == null) {
        return;
      }

      if (student.nutrition == null) {
        student.nutrition = {};
      }

      const nutrition = student.nutrition;
      if (!nutrition.workingDays) {
        nutrition.workingDays = 0;
      }
      if (!nutrition.weekendDays) {
        nutrition.weekendDays = 0;
      }
      if (!nutrition.holidayDays) {
        nutrition.holidayDays = 0;
      }
      if (!nutrition.vacationDays) {
        nutrition.vacationDays = 0;
      }

      if (!nutrition.workingDaysAdults) {
        nutrition.workingDaysAdults = 0;
      }
      if (!nutrition.weekendDaysAdults) {
        nutrition.weekendDaysAdults = 0;
      }
      if (!nutrition.holidayDaysAdults) {
        nutrition.holidayDaysAdults = 0;
      }
      if (!nutrition.vacationDaysAdults) {
        nutrition.vacationDaysAdults = 0;
      }

      if (!nutrition.totalSum) {
        nutrition.totalSum = 0;
      }

      this.onChange();
    },
    calcTotalSum() {
      let totalSum = 0;

      if (this.student != null) {
        const nutrition = this.student.nutrition;
        if (nutrition != null) {
          this.formula = '';
          this.formulaAdditional = '';
          this.totalMealAmount = 0;

          const workingDays = this.student.nutrition.workingDays || 0;
          const weekendDays = this.student.nutrition.weekendDays || 0;
          const holidayDays = this.student.nutrition.holidayDays || 0;
          const vacationDays = this.student.nutrition.vacationDays || 0;

          const workingDaysAdults = this.student.nutrition.workingDaysAdults || 0;
          const weekendDaysAdults = this.student.nutrition.weekendDaysAdults || 0;
          const holidayDaysAdults = this.student.nutrition.holidayDaysAdults || 0;
          const vacationDaysAdults = this.student.nutrition.vacationDaysAdults || 0;

          const mealAmount = this.student.university.region.mealAmount || 0;

          const total = ((workingDays * mealAmount) + (weekendDays + holidayDays + vacationDays) * (mealAmount + mealAmount / 10)) * 0.4;
          const totalAdults = ((workingDaysAdults * mealAmount) + (weekendDaysAdults + holidayDaysAdults + vacationDaysAdults) * (mealAmount + mealAmount / 10));
          this.totalMealAmount = total + totalAdults;

          const formula = `((${workingDays} * ${mealAmount}) + (${weekendDays} + ${holidayDays} + ${vacationDays}) * (${mealAmount} + ${mealAmount} / 10)) * 0.4`;
          const formulaAdults = `((${workingDaysAdults} * ${mealAmount}) + (${weekendDaysAdults} + ${holidayDaysAdults} + ${vacationDaysAdults}) * (${mealAmount} + ${mealAmount} / 10))`;
          this.formula = `${formula}`;
          this.formulaAdditional = `${formulaAdults}`;

          totalSum += this.totalMealAmount;
        }
      }

      this.student.nutrition.totalSum = totalSum;

      return totalSum;
    },
    isDisabled() {
      return !this.hasEditPermission();
    },
    onChange() {
      this.student.nutrition.totalSum = this.calcTotalSum();
    },
    hasEditPermission() {
      return this.isUniversityManager();
    },
    isAdmin() {
      return delegationService.isAdmin();
    },
    isUniversityManager() {
      return delegationService.isUniversityManager();
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}

.card {
  margin-bottom: 15px;
}

.p-3 {
  padding: 0.1rem !important;
}
</style>
